// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    company: "/company/info",
    preSignedURL: "/company/logo/pre_signed_url",
    updateCompanyLogo: `/company/logo/update/v2`,
    updateCompany: `/company/info/update`,
    //
    email: "/company/email/config/info",
    updateEmail: "/company/email/config/update",
    //
    sendTestEmail: "/company/email/test/send"
};

// ----------------------------------------------------------------------

const getBrandingPreSignedURL = () => axios.get(`${ API_ENDPOINTS.preSignedURL }`);

const sendTestEmail = (request) => axios.post(`${ API_ENDPOINTS.sendTestEmail }`, { ...request });

// ----------------------------------------------------------------------

const {
    useGetBrandingCompanyQuery,
    useUpdateCompanyLogoMutation,
    useUpdateCompanyMutation,
    //
    useGetTrackingEmailQuery,
    useUpdateTrackingEmailMutation
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getBrandingCompany: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "BrandingCompany" ],
            query: () => `${ API_ENDPOINTS.company }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        updateCompanyLogo: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.updateCompanyLogo }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "BrandingCompany" ] // 触发数据更新
        }),
        updateCompany: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.updateCompany }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "BrandingCompany" ] // 触发数据更新
        }),
        //
        getTrackingEmail: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "BrandingEmail" ],
            query: () => `${ API_ENDPOINTS.email }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        updateTrackingEmail: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.updateEmail }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "BrandingEmail" ] // 触发数据更新
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    getBrandingPreSignedURL as getBrandingPreSignedURLAPI,
    //
    sendTestEmail as sendTestEmailAPI,
    //
    useGetBrandingCompanyQuery,
    useUpdateCompanyLogoMutation,
    useUpdateCompanyMutation,
    //
    useGetTrackingEmailQuery,
    useUpdateTrackingEmailMutation
};
